import { object, string, TypeOf } from 'yup';

export const ListAMTemplateFilterSchema = object({
  name: string(),
});

export type ListAMTemplateFilterType = TypeOf<
  typeof ListAMTemplateFilterSchema
>;
